<template>
  <!--  保证金认证弹窗 -->
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="onHandleClose"
      width="500px"
      class="dialog"
      center
    >
      <div class="contents">
        <div class="mb-10">保证金金额：{{ detailInfo.earnest_money }}元</div>
        <div class="d-flex a-center" v-if="detailInfo.earnest_url">
          转账记录：
          <el-image
            mode=""
            :src="detailInfo.earnest_url"
            style="width: 150px; height: 150px"
            :preview-src-list="[detailInfo.earnest_url]"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onHandleClose">取 消</el-button>
        <el-button
          type="primary"
          :disabled="submitLoading"
          @click="onHandleSubmit"
          >{{
            detailInfo.earnest_status == 0 ? "确认收到" : "保证金已退款"
          }}</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { postLogisticsEarnestMoneyAudit } from "@/api/general/manager.js";

export default {
  name: "marginAuthenticationDialog",
  props: {},
  data() {
    return {
      dialogVisible: false,
      dialogTitle: "保证金认证",
      submitLoading: false,
      detailInfo: {},
    };
  },
  methods: {
    onInitData(data) {
      this.dialogVisible = true;
      this.detailInfo = data;
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.dialogVisible = false;
    },

    /**
     * 确认
     */
    onHandleSubmit() {
      this.submitLoading = true;
      this.postAjaxLogisticsEarnestMoneyAudit();
    },
    async postAjaxLogisticsEarnestMoneyAudit() {
      try {
        const res = await postLogisticsEarnestMoneyAudit({
          id: this.detailInfo.id,
          status: this.detailInfo.earnest_status == 0 ? 1 : 2, //状态 1收到 2 退款
        });
        this.dialogVisible = false;
        this.tool.message("操作成功", "success");
        this.$emit("on-refresh-list");
      } catch (error) {
        console.log(error, "postLogisticsEarnestMoneyAudit");
      } finally {
        this.submitLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.contents {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
</style>
